import { useDestinationFilteredProductAds, useProductAdsListViewed } from '@/scopes/product-ads/domain/hooks'
import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks'
import { useRef } from 'react'
import { ProductAdsComponent } from './ProductAds'
import { ProductAdsList } from './ProductAdsList'
import styles from './SearchTile.module.css'

export function SearchTileProductAds({
  infoLabel,
  infoContent,
  contextItemId,
  headerTitle,
}: {
  infoLabel: string
  infoContent: string
  headerTitle: string
  contextItemId: string
}) {
  const { selectedValues: countrySelectedValues } = useMultiSelectFilter('Country')
  const { selectedValues: regionSelectedValues } = useMultiSelectFilter('Region')
  const { isLoading, data } = useDestinationFilteredProductAds({
    contextItemId,
    destinations: { Country: countrySelectedValues, Region: regionSelectedValues },
    componentType: 'SearchList',
  })
  const productAdsRef = useRef(null)
  useProductAdsListViewed(data, 'sponsored_plp', productAdsRef)

  const content = !data || data.length === 0
    ? null
    : (
        <div className={styles.wrapper} data-qa="product-ads">
          <ProductAdsComponent infoLabel={infoLabel} infoContent={infoContent} headerTitle={headerTitle}>
            <ProductAdsList data={data} isLoading={isLoading} type="sponsored_plp" />
          </ProductAdsComponent>
        </div>
      )

  return <div ref={productAdsRef}>{content}</div>
}
